var React = require('react');

function QuestionMark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"32","cy":"32","r":"32","fill":"#FF863B","key":0}),React.createElement("text",{"x":"32","y":"32","fontFamily":"Arial, sans-serif","fontSize":"40","fill":"white","textAnchor":"middle","alignmentBaseline":"central","key":1},"?")]);
}

QuestionMark.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none"};

module.exports = QuestionMark;

QuestionMark.default = QuestionMark;
